"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var UserDetails_1 = require("./UserDetails");
var UserDetailsWrapper = function (_a) {
    var customer = _a.customer, showPhonePrefix = _a.showPhonePrefix, paymentInformation = _a.paymentInformation;
    var _b, _c, _d;
    if (!customer.firstName) {
        return null;
    }
    return (<UserDetails_1.default firstname={customer.firstName} lastname={customer.lastName} email={customer.email} phone={customer.phone} areaCode={(_b = customer.attributes) === null || _b === void 0 ? void 0 : _b.areaCode} areaCodeKey={(_c = customer.attributes) === null || _c === void 0 ? void 0 : _c.areaCodeKey} preferredContactMethod={(_d = customer.attributes) === null || _d === void 0 ? void 0 : _d.preferredContactMethod} showPhonePrefix={showPhonePrefix} companyName={customer.companyName} customerType={customer.customerType} identificationNumber={customer.identificationNumber} paymentInformation={paymentInformation}/>);
};
exports.default = UserDetailsWrapper;
